import React, {useState, useEffect} from "react";

import db from "../../../../services/query";

import PrintTable from "../../common/PrintTable";
import Img from "../../../common/Img";
import AriaLogoNew from "../../../../icons/aria-logo-new";


const ExamResults = (props) => {
    const { activeSem, studentId } = props.match.params;
    const [data, setData] = useState([]);

    const renderResult = (e, noColor) =>{
        let res = '';
        if(e.result === null) res = '-';
        else if(e.result === 0) res = 'Failed';
        else if(e.result === 1) res = 'Passed';
        else if(e.result === 3) res = 'Disqualified';
        else res = e.result;

        return <b className={ !noColor ? `result-result-${e.result}` : ''}>{res}</b>
    }

    const renderChance = (e) =>{
        return (
            <div className={'result-chances'}>
                {e.chance_no >= 1 && <div>1</div>}
                {e.chance_no >= 2 && <div>2</div>}
                {e.chance_no >= 3 && <div>3</div>}
                {e.chance_no >= 4 && <div>4</div>}
            </div>
        )
    }

    const columns = [
        { path: "result", label: "RESULT" , content: (e) => renderResult(e, true)},
        { path: "grade", label: "GRADE", content: (e) => <b>{e.grade}</b>  },
        { path: "total", label: "MARK", content: (e) => <b>{e.total}</b>  },
        { path: "credits", label: "CREDITS", content: (e) => <b>{e.credits}</b>  },
        { path: "subject_name", label: "SUBJECT"},
        // { path: "chance_no", label: "CHANCE",    content: (e) => renderChance(e) },
        { path: "id", label: "NO" },
    ];

    const gSColumns = [
        { path: "description", label: "DESCRIPTIONS" },
        { path: "grade", label: "GRADE" },
        { path: "mark", label: "MARKS" ,},
    ];

    const gSData = [
        { mark: "90 - 100", grade: "A", description: "Excellent"},
        { mark: "75 - 89", grade: "B", description: "Very Good"},
        { mark: "60 - 74", grade: "C", description: "Good"},
        { mark: "55 - 59", grade: "D", description: "Acceptable"},
        { mark: "0 - 54", grade: "F", description: "Fail"},
    ];


    useEffect(() => {
        // to remove gradiant effect
        document.body.classList.add('no-linear-gradient');

        requestData();

        return () => setData([]);
    }, []);

    const requestData = async () => {
        let query = `results/students/${studentId}`;

        await db.getAll(query).then(({data}) => {
            setData(data);
            console.log(data)
        })
    }

    return (
        <main className="exam-result exam-result-print">
            {/* blue header */}
            <div className="exam-result-blue-header">
                <div className="exam-result-header-inner">
                    <div className="exam-result-header-right">
                        <p style={{fontWeight: "bold"}}>پوهنتون آریا</p>
                        <p>Student Affairs Department</p>
                        <p>{data?.data && data.data[activeSem]?.faculty_name_en} Faculty</p>
                        <p>{data?.data && data.data[activeSem]?.class_desc_en} ({data?.data && data.data[activeSem]?.time_name_en})</p>
                    </div>

                    <div className='aria-logo exam-result-header-logo'>
                        <AriaLogoNew />
                    </div>

                    <div className="exam-result-header-left">
                        <h4 style={{fontWeight: "normal"}}>پوهنتون آریا</h4>
                        <h2 style={{fontWeight: "normal"}}>Exam Results</h2>
                    </div>
                </div>
            </div>

            <div className="main-print-wrapper" style={{paddingTop: "0",}}>
                {/* profile area */}
                <div className="exam-result-profile-area exam-result-profile-block">
                    <div className="exam-result-profile-details">
                        <h3>{data?.data && data.data[activeSem]?.student_name_en}</h3>
                        <h5>{data?.data && data.data[activeSem]?.student_father_name_en}</h5>
                        <p className="exam-result-student-id">
                            Student ID: {(data?.summary?.aria_id || data?.data?.[activeSem]?.aria_id || '-')}
                        </p>
                    </div>
                    <div className="std-profile exam-result-student-photo">
                        <div className="wrapper">
                            <Img src={data?.summary?.student_photo} border={true} />
                        </div>
                    </div>
                </div>

                {/* result table */}
                <PrintTable columns={columns} data={data?.data && data.data[activeSem]?.subjects}/>


                {/* summary area */}
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "49% 49%",
                    gap: "2%",
                    marginTop: "10px",
                }}>
                    <div className="grading-system-table white-background-with-border">
                        <p>THE GRADING SYSTEM</p>
                        <PrintTable data={gSData} columns={gSColumns} />
                    </div>
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "auto auto"
                    }}>
                        <div className="wrapper">
                            <p style={{color:"var(--font-color)"}}>Rank</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.rank}</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>G.P.A.</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.GPA}</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>Percentage</p>
                            <h3 style={{color:"#004D98"}}>{data?.data && data.data[activeSem]?.percentage}%</h3>
                        </div>
                        <div className="wrapper">
                            <p style={{color:" var(--font-color)"}}>Result</p>
                            <h3 style={{color:"#004D98"}}>{renderResult(data?.data && data.data[activeSem] ? data.data[activeSem] : {}, true)}</h3>
                        </div>
                    </div>
                </div>

                {/* signature area */}
                <div style={{
                    display: "grid",
                    gridTemplateColumns: "auto auto",
                    paddingTop: "50px",
                    textTransform: "uppercase"
                }}>
                    <div className="print-identity">
                        <div className="print-signature-area">
                            <div className="wrapper" style={{width: "70%"}}>
                                <hr/>
                                <p>Signature of<br/>the head of Faculty</p>
                            </div>
                        </div>
                    </div>
                    <div className="print-identity">
                        <div className="print-signature-area">
                            <div className="wrapper" style={{width: "70%"}}>
                                <hr/>
                                <p>Signature of<br/>the faculty administrator</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default ExamResults;
